// Can drop anywhere!
function getValidDropIndexesForNonSections (preparedItems) {
  return preparedItems.map((_, index) => index);
}

export default getValidDropIndexesForNonSections;
